<template>
    <div class="big_box" :class="filterMode === 'inline' ? 'inline-mode' : 'drawer-mode'">
        <!-- ========== INLINE 模式（stockType 风格） ========== -->
        <div v-if="filterMode === 'inline'" class="header_warpper inline-mode">
            <div class="left">
                <el-form
                    :model="form"
                    :rules="computedRules"
                    ref="ruleForm"
                    label-position="top"
                    :inline="true"
                    style="display: flex; flex-wrap: wrap"
                >
                    <template v-for="(item, index) in allArr.item">
                        <el-form-item
                            :prop="item.ismust == 1 ? item.item_no : null"
                            :label="item.item_name"
                            style=""
                            :key="index"
                            v-if="(item.type == 'select' || item.type == 'select-multiple') && item.status == 1"
                        >
                            <mySelectOptimized
                                v-model="form[item.item_no]"
                                :options="allArr.value[item.item_no.replace('_no', '')] || []"
                                :values="item.item_no.replace('_no', '') + '_no'"
                                :labels="item.item_no.replace('_no', '') + '_name'"
                                :keys="item.item_no.replace('_no', '') + '_no'"
                                :multiple="item.type == 'select-multiple'"
                                :clearables="true"
                                :placeholders="'请选择' + item.item_name"
                                size="mini"
                                @selectChange="changeData(item, item.type)"
                                @clear="handleClear(item)"
                                style="width: 100%"
                            />
                        </el-form-item>
                        <el-form-item
                            :prop="item.ismust == 1 ? item.item_no : null"
                            :label="item.item_name"
                            style=""
                            :key="'i' + index"
                            v-else-if="(item.type == 'number' || item.type == 'text') && item.status == 1"
                        >
                            <el-input
                                v-model="form[item.item_no]"
                                :type="item.type"
                                :placeholder="'请输入' + item.item_name"
                                style="width: 100%"
                            ></el-input>
                        </el-form-item>
                        <el-form-item
                            :prop="item.ismust == 1 ? item.item_no : null"
                            :label="item.item_name"
                            v-else-if="item.type == 'switch' && item.status == 1"
                            :key="'s' + index"
                            style=""
                        >
                            <el-tag :type="form[item.item_no] == '1' ? 'success' : form[item.item_no] == '0' ? 'danger' : ''">{{ form[item.item_no] == 1 ? '是' : '否' }}</el-tag>
                            <el-switch style="margin-left: 5px" v-model="form[item.item_no]" :active-value="1" :inactive-value="0"></el-switch>
                        </el-form-item>
                        <el-form-item
                            :prop="item.ismust == 1 ? item.item_no : null"
                            :key="'d' + index"
                            :label="item.item_name"
                            style=""
                            v-else-if="item.status == 1 && ['date', 'datetime', 'daterange', 'datetimerange'].includes(item.type)"
                        >
                            <el-date-picker
                                v-bind="getDatePickerProps(item)"
                                v-model="form[item.item_no]"
                                @blur="(value) => getTimes(value, item)"
                                @change="(value) => changeTime(value, item)"
                            />
                        </el-form-item>
                    </template>
                </el-form>
            </div>
            <div class="right">
                <el-button @click="searchIt">{{ $t('common.search') }}</el-button>
                <el-button @click="outExcel">{{ $t('common.export') }}</el-button>
                <el-button @click="changeTable(dtlArr.head)" icon="el-icon-setting"></el-button>
            </div>
        </div>

        <!-- ========== DRAWER 模式（wageTotalSaleman 风格） ========== -->
        <div v-else-if="filterMode === 'drawer'" class="header_warpper drawer-mode">
            <div class="left">
                <el-form
                    :rules="computedRules"
                    :model="form"
                    ref="ruleForm"
                    label-position="top"
                    :inline="true"
                    style="display: flex; flex-wrap: wrap"
                >
                    <el-tabs v-model="tabPosition" @tab-click="(tab) => handleClick(tab, form)" style="margin-right: 10px">
                        <el-tab-pane label="今日" name="today"></el-tab-pane>
                        <el-tab-pane label="昨日" name="zuori"></el-tab-pane>
                        <el-tab-pane label="本月" name="benyue"></el-tab-pane>
                        <el-tab-pane label="上月" name="shangyue"></el-tab-pane>
                    </el-tabs>
                </el-form>
            </div>
            <div class="right">
                <el-button @click="freshen">{{ $t('common.refresh') }}</el-button>
                <el-button @click="IsShowClick">{{ $t('common.filter') }}</el-button>
                <el-button @click="outExcel">{{ $t('common.export') }}</el-button>
                <el-button @click="changeTable(dtlArr.head)" icon="el-icon-setting"></el-button>
            </div>
        </div>

        <!-- ========== 表格区域（两种模式共用） ========== -->
        <template>
            <div class="selectTableBox" :class="filterMode === 'inline' ? 'inline-mode' : 'drawer-mode'">
                <el-table
                    border
                    :height="filterMode === 'inline' ? 'calc(100vh - 350px)' : 'calc(100vh - 320px)'"
                    :data="dtlArr.data"
                    style="width: 100%;  font-size: 14px"
                    :summary-method="(param) => getSummaries(param, dtlArr, systemSet)"
                    show-summary
                    :key="refushTable"
                >
                    <template slot="empty">
                        <div style="display: flex; justify-content: center; align-items: center; height: calc(100vh - 320px)">
                            <img src="@/assets/img/dontHave.png" alt="" style="width: 250px; height: 250px" />
                        </div>
                    </template>
                    <el-table-column
                        v-for="(item, index) in dtlArr.head"
                        :key="index"
                        :label="item.title"
                        v-if="!item.children && item.status == 1"
                        :prop="item.field"
                        :width="item.field == 'seq' || item.title == '序号' ? 50 : 160"
                        :align="item.field == 'seq' || item.title == '序号' ? 'center' : 'left'"
                        :sortable="item.issort == 1"
                        :sort-method="(a, b) => a[item.field] - b[item.field]"
                    >
                        <template v-slot="scope">
                            <div v-if="item.field == 'bill_no'">
                                <el-button type="text" @click="handleDetails(scope.row)">{{ scope.row.bill_no }}</el-button>
                            </div>
                            <div v-else>{{ scope.row[item.field] }}</div>
                        </template>
                    </el-table-column>
                    <el-table-column
                        v-else-if="item.children && item.children.some(child => child.status == 1)"
                        :label="item.title"
                        :key="'parent_' + index"
                    >
                        <el-table-column
                            v-for="(child, childIndex) in item.children"
                            :key="childIndex"
                            :prop="child.field"
                            :label="child.title"
                            :width="child.field == 'seq' || child.title == '序号' ? 50 : 160"
                            :align="child.field == 'seq' || child.title == '序号' ? 'center' : 'left'"
                            :sortable="child.issort == 1"
                            v-if="child.status == 1"
                            :sort-method="(a, b) => a[child.field] - b[child.field]"
                        >
                            <template v-slot="scope">
                                <div v-if="child.field == 'bill_no'">
                                    <el-button type="text" @click="handleDetails(scope.row)">{{ scope.row.bill_no }}</el-button>
                                </div>
                                <div v-else>{{ scope.row[child.field] }}</div>
                            </template>
                        </el-table-column>
                    </el-table-column>
                </el-table>
                <div class="pagination">
                    <el-pagination
                        background
                        layout="total, sizes, prev, pager, next, jumper"
                        :current-page="form.page"
                        :page-size="form.page_size"
                        :page-sizes="[100, 200, 300, pageTotal]"
                        :total="pageTotal"
                        @current-change="handlePageChange"
                        @size-change="page_sizeChange"
                    ></el-pagination>
                </div>
            </div>
        </template>

        <!-- ========== DRAWER 模式：筛选抽屉 ========== -->
        <el-drawer v-if="filterMode === 'drawer'" :title="$t('common.filter')" :visible.sync="outData_IsShow" direction="rtl" size="38%">
            <div class="drawer-wrapper">
                <el-form
                    :model="form"
                    :rules="computedRules"
                    ref="ruleForm"
                    label-position="top"
                    :inline="true"
                    style="display: flex; flex-wrap: wrap"
                >
                    <template v-for="(item, index) in allArr.item">
                        <el-form-item
                            :prop="item.ismust == 1 ? item.item_no : null"
                            :label="item.item_name"
                            style="width: 48%"
                            :key="'dI' + index"
                            v-if="(item.type == 'select' || item.type == 'select-multiple') && item.status == 1"
                        >
                            <mySelectOptimized
                                v-model="form[item.item_no]"
                                :options="allArr.value[item.item_no.replace('_no', '')] || []"
                                :values="item.item_no.replace('_no', '') + '_no'"
                                :labels="item.item_no.replace('_no', '') + '_name'"
                                :keys="item.item_no.replace('_no', '') + '_no'"
                                :multiple="item.type == 'select-multiple'"
                                :clearables="true"
                                :placeholders="'请选择' + item.item_name"
                                size="mini"
                                @selectChange="changeData(item, item.type)"
                                @clear="handleClear(item)"
                                style="width: 100%"
                            />
                        </el-form-item>
                        <el-form-item
                            :prop="item.ismust == 1 ? item.item_no : null"
                            :label="item.item_name"
                            style="width: 48%"
                            :key="'dT' + index"
                            v-else-if="(item.type == 'number' || item.type == 'text') && item.status == 1"
                        >
                            <el-input
                                v-model="form[item.item_no]"
                                :type="item.type"
                                :placeholder="'请输入' + item.item_name"
                                style="width: 100%"
                            ></el-input>
                        </el-form-item>
                        <el-form-item
                            :prop="item.ismust == 1 ? item.item_no : null"
                            :label="item.item_name"
                            v-else-if="item.type == 'switch' && item.status == 1"
                            :key="'dS' + index"
                            style="width: 48%"
                        >
                            <el-tag :type="form[item.item_no] == '1' ? 'success' : form[item.item_no] == '0' ? 'danger' : ''">{{ form[item.item_no] == 1 ? '是' : '否' }}</el-tag>
                            <el-switch style="margin-left: 5px" v-model="form[item.item_no]" :active-value="1" :inactive-value="0"></el-switch>
                        </el-form-item>
                        <el-form-item
                            :prop="item.ismust == 1 ? item.item_no : null"
                            :key="'dD' + index"
                            :label="item.item_name"
                            style="width: 48%"
                            v-else-if="item.status == 1 && ['date', 'datetime', 'daterange', 'datetimerange'].includes(item.type)"
                        >
                            <el-date-picker
                                v-bind="getDatePickerProps(item)"
                                v-model="form[item.item_no]"
                                @blur="(value) => getTimes(value, item)"
                                @change="(value) => changeTime(value, item)"
                            />
                        </el-form-item>
                    </template>
                </el-form>
                <div class="filter-footer">
                    <el-button @click="outData_IsShow = false">取 消</el-button>
                    <el-button type="primary" @click="searchIt()">确 定</el-button>
                </div>
            </div>
        </el-drawer>

        <!-- ========== 列配置抽屉（两种模式共用） ========== -->
        <el-drawer title="我是标题" :visible.sync="drawers" :direction="direction" :with-header="false">
            <div class="filterKey_box">
                <div class="box_header">
                    <span>列配置</span>
                    <i class="el-icon-close icon" @click="drawers = false"></i>
                </div>
                <div class="box_content">
                    <div class="small_box">
                        <div class="text">
                            <span class="big">已显示字段</span>
                            <span class="small">拖动可调整字段顺序</span>
                        </div>
                        <ul class="ul">
                            <draggable
                                :list="keyList"
                                class="list-group"
                                ghost-class="ghost"
                                :move="checkMove"
                                animation="1000"
                                force-fallback="true"
                                chosen-class="chosen"
                            >
                                <li
                                    class="li"
                                    v-for="(item, index) in keyList"
                                    :key="index"
                                    v-show="item.status == 1"
                                    @mouseover="showIndex = index"
                                    @mouseleave="showIndex = null"
                                >
                                    <i class="el-icon-s-grid icon"></i>
                                    {{ item.title }}
                                    <i class="el-icon-error delIcon" v-show="showIndex == index" @click="liClick('del', item, index)"></i>
                                </li>
                            </draggable>
                        </ul>
                    </div>
                    <div class="small_box">
                        <div class="text">
                            <span class="big">可选字段</span>
                            <span class="small"></span>
                        </div>
                        <ul class="ul">
                            <draggable :list="keyList" :disabled="true" class="list-group" ghost-class="ghost" :move="checkMove">
                                <transition-group>
                                    <li
                                        class="li hover"
                                        v-for="(item, index) in keyList"
                                        :key="'opt_' + index"
                                        v-show="item.status == 0"
                                        @mouseover="optionalIndex = index"
                                        @mouseleave="optionalIndex = null"
                                        @click="liClick('add', item, index)"
                                    >
                                        <i class="el-icon-circle-plus-outline icon2" v-show="optionalIndex == index"></i>
                                        {{ item.title }}
                                    </li>
                                </transition-group>
                            </draggable>
                        </ul>
                    </div>
                    <div class="box_btn">
                        <el-button @click="keycancel" style="font-size: 14px">{{ $t('common.cancel') }}</el-button>
                        <el-button @click="keyConfirm" type="primary" style="font-size: 14px">{{ $t('common.confirm') }}</el-button>
                    </div>
                </div>
            </div>
        </el-drawer>
    </div>
</template>

<script>
import { getColumnTitleByLang } from '@/utils/columnI18n';
import { apiGetListCorrespondingReportData } from '@/request/api';
export default {
    name: 'ReportTableChildren',
    props: {
        apiConfig: {
            type: Object,
            required: true,
            default: () => ({
                pull: null,
                getData: null,
                exportData: null
            })
        },
        dateField: {
            type: String,
            default: 'billDateRange'
        },
        showTabs: {
            type: Boolean,
            default: true
        },
        filterMode: {
            type: String,
            default: 'drawer',
            validator: (val) => ['inline', 'drawer'].includes(val)
        }
    },
    data() {
        let self = this;
        return {
            originalHead: [],
            originalItems: [],
            tableScrollTop: 0,
            keyList: [],
            drawers: false,
            direction: 'rtl',
            showIndex: null,
            optionalIndex: null,
            refushTable: true,
            missingFields: '',
            mulStyle: '',
            outData_IsShow: false,
            tabPosition: 'today',
            dtlArr: { head: [], data: [] },
            allArr: { item: [], value: {} },
            title_name: '',
            form: {
                page: 1,
                page_size: 10,
                billDateRange: []
            },
            pageTotal: 0,
            perData: '',
            systemSet: JSON.parse(localStorage.getItem('systemSet') || '{}'),
            dateTime: '',
            pickerOptions: {
                shortcuts: [
                    {
                        text: '今天',
                        onClick(picker) {
                            if (self.tabPosition !== 'today') { self.tabPosition = 'today'; }
                            const end = new Date();
                            const start = new Date();
                            start.setHours(0, 0, 0, 0);
                            end.setHours(23, 59, 59, 999);
                            self.dateTime = [start, end];
                            picker.$emit('pick', [start, end]);
                        }
                    },
                    {
                        text: '昨日',
                        onClick(picker) {
                            if (self.tabPosition !== 'zuori') { self.tabPosition = 'zuori'; }
                            const end = new Date();
                            const start = new Date();
                            start.setTime(start.getTime() - 3600 * 1000 * 24);
                            start.setHours(0, 0, 0, 0);
                            end.setHours(23, 59, 59, 999);
                            self.dateTime = [start, end];
                            picker.$emit('pick', [start, end]);
                        }
                    },
                    {
                        text: '本月',
                        onClick(picker) {
                            if (self.tabPosition !== 'benyue') { self.tabPosition = 'benyue'; }
                            let currentDate = new Date();
                            let currentMonth = currentDate.getMonth();
                            let currentYear = currentDate.getFullYear();
                            const start = new Date(currentYear, currentMonth, 1);
                            const end = new Date(currentYear, currentMonth + 1, 0);
                            end.setHours(23, 59, 59, 999);
                            self.dateTime = [start, end];
                            picker.$emit('pick', [start, end]);
                        }
                    },
                    {
                        text: '上月',
                        onClick(picker) {
                            if (self.tabPosition !== 'shangyue') { self.tabPosition = 'shangyue'; }
                            let currentDate = new Date();
                            let currentMonth = currentDate.getMonth();
                            let currentYear = currentDate.getFullYear();
                            if (currentMonth === 0) { currentMonth = 11; currentYear--; } else { currentMonth--; }
                            const start = new Date(currentYear, currentMonth, 1);
                            const end = new Date(currentYear, currentMonth + 1, 0);
                            end.setHours(23, 59, 59, 999);
                            self.dateTime = [start, end];
                            picker.$emit('pick', [start, end]);
                        }
                    }
                ]
            }
        };
    },
    activated() {
        this.$nextTick(() => {
            const tableBody = document.querySelector('.el-table__body-wrapper');
            if (tableBody) { tableBody.scrollTop = this.tableScrollTop; }
        });
    },
    deactivated() {
        const tableBody = document.querySelector('.el-table__body-wrapper');
        if (tableBody) { this.tableScrollTop = tableBody.scrollTop; }
    },
    watch: {
        '$i18n.locale'() {
            this.updateColumnTitles();
            this.updateFormItemNames();
        }
    },
    created() {
        this.$set(this.form, this.dateField, []);
        this.getPull();
    },
    computed: {
        computedRules() {
            const rules = {};
            if (this.allArr.item) {
                this.allArr.item.forEach((item) => {
                    if (item.ismust == 1) {
                        if (['date', 'datetime', 'daterange', 'datetimerange'].includes(item.type)) {
                            rules[item.item_no] = [{ required: true, message: `请选择${item.item_name}`, trigger: 'change' }];
                        } else if (['select', 'switch', 'select-multiple'].includes(item.type)) {
                            rules[item.item_no] = [{ required: true, message: `请选择${item.item_name}`, trigger: 'change' }];
                        } else {
                            rules[item.item_no] = [{ required: true, message: `${item.item_name}不能为空`, trigger: 'blur' }];
                        }
                    }
                });
            }
            return rules;
        }
    },
    methods: {
        updateColumnTitles() {
            if (!this.dtlArr || !this.dtlArr.head || !this.originalHead.length) return;
            const lang = this.$i18n ? this.$i18n.locale : 'zh-CN';
            this.dtlArr.head = this.originalHead.map(item => ({ ...item, title: getColumnTitleByLang(item, lang, 'title') }));
            if (this.keyList && this.keyList.length) {
                this.keyList = this.keyList.map(item => ({ ...item, title: getColumnTitleByLang(item, lang, 'title') }));
            }
        },
        updateFormItemNames() {
            if (!this.allArr || !this.allArr.item || !this.originalItems.length) return;
            const lang = this.$i18n ? this.$i18n.locale : 'zh-CN';
            this.allArr.item = this.originalItems.map(item => ({ ...item, item_name: getColumnTitleByLang(item, lang, 'item_name') }));
        },
        changeTable(data) {
            this.drawers = true;
            this.keyList = data;
        },
        liClick(type, item, index) {
            if (type === 'del') { this.$set(this.keyList[index], 'status', '0'); }
            else if (type === 'add') { this.$set(this.keyList[index], 'status', '1'); }
        },
        checkMove() {},
        keycancel() {
            this.drawers = false;
            this.getData();
        },
        keyConfirm() {
            if (this.keyList) {
                apiGetListCorrespondingReportData({ head: this.keyList }).then((res) => {
                    this.drawers = false;
                    if (res.code == 2000) {
                        this.$message.success(res.msg);
                        this.refushTable = !this.refushTable;
                    } else if (res.code == 4000) {
                        this.$message.warning(res.data.info);
                    } else {
                        this.$message.error(res.msg);
                    }
                });
            }
        },
        getDatePickerProps(item) {
            const baseProps = { style: 'width: 99%', placeholder: '选择' + item.item_name };
            switch (item.type) {
                case 'date': return { ...baseProps, type: 'date', valueFormat: 'yyyy-MM-dd' };
                case 'datetime': return { ...baseProps, type: 'datetime', valueFormat: 'yyyy-MM-dd HH:mm:ss' };
                case 'daterange': return { ...baseProps, type: 'daterange', valueFormat: 'yyyy-MM-dd', startPlaceholder: '开始日期', endPlaceholder: '结束日期', defaultTime: ['00:00:00', '23:59:59'], pickerOptions: this.pickerOptions };
                case 'datetimerange': return { ...baseProps, type: 'datetimerange', valueFormat: 'yyyy-MM-dd HH:mm:ss', startPlaceholder: '开始日期', endPlaceholder: '结束日期', defaultTime: ['00:00:00', '23:59:59'], pickerOptions: this.pickerOptions };
                default: return {};
            }
        },
        freshen() {
            if (Array.isArray(this.missingFields)) {
                const allFieldsHaveValue = this.missingFields.every((field) => this.form && this.form[field] && this.form[field] !== '');
                if (allFieldsHaveValue) { this.searchIt(); } else { this.getPull(); }
            }
        },
        IsShowClick() {
            this.outData_IsShow = true;
            if (this.mulStyle) {
                this.mulStyle.forEach((key) => {
                    let value = this.form[key];
                    if (typeof value == 'string') {
                        if (value) { this.form[key] = value.split(','); }
                    }
                });
            }
        },
      handleDetails(row) {
          console.log(row);
            if (row.allow_use == '0') {
                this.$message.error('暂无权限');
            } else {
                if (row.bill_code) {
                    this.$router.push({ path: '/' + row.bill_code, query: { bill_no: row.bill_no } });
                }
            }
        },
        changeTime(val, row) {
            if (val == null || (Array.isArray(val) && val.length === 0)) {
                setTimeout(() => {
                    const today = this.formatDate(new Date());
                    this.form[row.item_no] = [today, today];
                    this.dateTime = [today, today];
                    this.tabPosition = 'today';
                }, 500);
            } else {
                this.tabPosition = '';
            }
        },
        getTimes(event, row) {
            if (!this.form[row.item_no]) { this.$set(this.form, row.item_no, []); }
            if (event && event.displayValue && event.displayValue.length === 2) {
                this.form[row.item_no] = [event.displayValue[0], event.displayValue[1]];
            }
        },
        formatDate(date) {
            if (!date) return '';
            const year = date.getFullYear();
            let month = date.getMonth() + 1;
            let day = date.getDate();
            if (month < 10) month = `0${month}`;
            if (day < 10) day = `0${day}`;
            return `${year}-${month}-${day}`;
        },
        handleClick(tab, row) {
            const fieldName = this.dateField;
            if (!Array.isArray(this.form[fieldName])) { this.$set(this.form, fieldName, []); }
            const date = new Date();
            const year = date.getFullYear();
            const month = date.getMonth();
            const day = date.getDate();
            let tabName = tab.name || tab;
            if (tabName == 'today') {
                this.form[fieldName][0] = this.formatDate(new Date());
                this.form[fieldName][1] = this.formatDate(new Date());
                this.tabPosition = 'today';
            } else if (tabName == 'zuori') {
                this.form[fieldName][0] = this.formatDate(new Date(year, month, day - 1));
                this.form[fieldName][1] = this.formatDate(new Date(year, month, day - 1));
                this.tabPosition = 'zuori';
            } else if (tabName == 'benyue') {
                this.form[fieldName][0] = this.formatDate(new Date(year, month, 1));
                this.form[fieldName][1] = this.formatDate(new Date(year, month + 1, 0));
                this.tabPosition = 'benyue';
            } else if (tabName == 'shangyue') {
                this.form[fieldName][0] = this.formatDate(new Date(year, month - 1, 1));
                this.form[fieldName][1] = this.formatDate(new Date(year, month, 0));
                this.tabPosition = 'shangyue';
            }
            this.form[fieldName] = [this.form[fieldName][0], this.form[fieldName][1]];
            this.dateTime = [this.form[fieldName][0], this.form[fieldName][1]];
            if (!row || !this.allArr.item || this.allArr.item.length === 0) { return; }
            let missingFieldsData = [];
            let missingFields = [];
            this.allArr.item.forEach((item) => {
                if (item.ismust == 1) {
                    const fieldValue = row[item.item_no];
                    if (!fieldValue || fieldValue == '' || fieldValue == null || (Array.isArray(fieldValue) && fieldValue.length == 0)) {
                        missingFieldsData.push(item.item_name);
                        missingFields.push(item.item_no);
                    }
                }
            });
            this.missingFields = missingFields;
            if (missingFieldsData.length > 0 && missingFields.filter((field) => field !== fieldName).length > 0) {
                this.outData_IsShow = true;
                const missingFieldsStr = missingFieldsData.join(', ');
                this.$message.error(`以下字段是必选项，请填写或选择${missingFieldsStr}`);
            } else {
                this.searchIt();
            }
        },
        getPull() {
            if (typeof this.apiConfig.pull !== 'function') { this.searchIt(); return; }
            this.$load.show();
            this.apiConfig.pull({}).then((res) => {
                this.$load.close();
                if (res.code == 2000) {
                    this.allArr = res.data;
                    this.title_name = res.module;
                    this.originalHead = res.data.head ? JSON.parse(JSON.stringify(res.data.head)) : [];
                    this.originalItems = res.data.item ? JSON.parse(JSON.stringify(res.data.item)) : [];
                    this.updateColumnTitles();
                    this.updateFormItemNames();
                    if (this.showTabs) {
                        this.handleClick('today', this.allArr);
                    } else {
                        this.searchIt();
                    }
                } else {
                    this.$message.error(res.data.info);
                }
            }).catch(() => { this.$load.close(); this.searchIt(); });
        },
        handleClear(item) { this.form[item.item_no] = ''; },
        changeData(row, e) {
            if (e == 'select-multiple') {
                if (!this.mulStyle) { this.mulStyle = new Set(); }
                this.mulStyle.add(row.item_no);
            }
        },
        searchIt() {
            this.form.page = 1;
            this.form.page_size = 100;
            this.getData();
        },
        getData() {
            let data = JSON.parse(JSON.stringify(this.form));
            Object.keys(data).forEach((key) => {
                if (Array.isArray(data[key]) && data[key].length === 0) { delete data[key]; }
                else if (data[key] === '' || data[key] === null || data[key] === undefined) { delete data[key]; }
            });
            if (this.mulStyle) {
                this.mulStyle.forEach((key) => {
                    if (Array.isArray(data[key])) { data[key] = data[key].join(','); }
                });
            }
            let formRef = this.filterMode === 'drawer' ? this.$refs.drawerRuleForm : this.$refs.ruleForm;
            if (!formRef) { formRef = this.$refs.ruleForm || this.$refs.drawerRuleForm; }
            if (formRef && typeof formRef.validate === 'function') {
                formRef.validate((valid) => {
                    if (valid) { this.doFetchData(data); }
                    else { return false; }
                });
            } else {
                this.doFetchData(data);
            }
        },
        doFetchData(data) {
            if (typeof this.apiConfig.getData !== 'function') { this.$message.warning('未配置数据接口'); return; }
            this.$load.show();
            this.apiConfig.getData(data).then((res) => {
                if (res.code == 2000) {
                    this.outData_IsShow = false;
                    this.dtlArr = res.data;
                    this.pageTotal = res.data.count;
                    if (res.data.head) { this.originalHead = JSON.parse(JSON.stringify(res.data.head)); }
                    this.updateColumnTitles();
                    this.$message.success(res.msg);
                    this.$load.close();
                } else {
                    this.dtlArr = { head: [], data: [] };
                    this.pageTotal = 0;
                    this.outData_IsShow = false;
                    this.$message.error(res.data.info);
                    this.$load.close();
                }
            }).catch(() => {
                this.$load.close();
                this.dtlArr = { head: [], data: [] };
                this.pageTotal = 0;
            });
        },
        mergeCol(id, rowIndex) {
            var idName = this.dtlArr.data[rowIndex][id];
            if (rowIndex > 0) {
                if (this.dtlArr.data[rowIndex][id] != this.dtlArr.data[rowIndex - 1][id]) {
                    var i = rowIndex; var num = 0;
                    while (i < this.dtlArr.data.length) { if (this.dtlArr.data[i][id] === idName) { i++; num++; } else { i = this.dtlArr.data.length; } }
                    return { rowspan: num, colspan: 1 };
                } else { return { rowspan: 0, colspan: 1 }; }
            } else {
                let i = rowIndex; let num = 0;
                while (i < this.dtlArr.data.length) { if (this.dtlArr.data[i][id] === idName) { i++; num++; } else { i = this.dtlArr.data.length; } }
                return { rowspan: num, colspan: 1 };
            }
        },
        objectSpanMethod({ row, column, rowIndex, columnIndex }) {
            switch (columnIndex) {
                case 1: return this.mergeCol('bill_no', rowIndex);
                case 2: return this.mergeCol('bill_no', rowIndex);
                case 3: return this.mergeCol('bill_no', rowIndex);
                case 4: return this.mergeCol('bill_no', rowIndex);
                case 5: return this.mergeCol('bill_no', rowIndex);
                case 6: return this.mergeCol('bill_no', rowIndex);
                case 7: return this.mergeCol('bill_no', rowIndex);
                case 8: return this.mergeCol('bill_no', rowIndex);
            }
        },
        handlePageChange(val) { this.form.page = val; this.getData(); },
        page_sizeChange(val) { this.form.page = 1; this.form.page_size = val; this.getData(); },
        outExcel() {
            if (typeof this.apiConfig.exportData !== 'function') { this.$message.warning('未配置导出接口'); return; }
            this.$load.show();
            this.form.login_staff = localStorage.getItem('ms_username');
            this.form.is_exports = 1;
            let data = JSON.parse(JSON.stringify(this.form));
            if (this.mulStyle) {
                this.mulStyle.forEach((key) => { if (Array.isArray(data[key])) { data[key] = data[key].join(','); } });
            }
            this.apiConfig.exportData(data).then((res) => {
                let blob = new Blob([res.data], { type: 'application/x-xls' });
                let link = document.createElement('a');
                link.href = window.URL.createObjectURL(blob);
                link.download = this.title_name + '.xlsx';
                link.click();
                this.form.is_exports = 0;
                this.$load.close();
            }).catch(() => { this.$load.close(); });
        },
        getSummaries(param, dtlArr, systemSet) {
            const { columns, data } = param;
            const sums = [];
            try {
                if (!dtlArr || !dtlArr.head || !Array.isArray(dtlArr.head)) { return sums; }
                let flatHead = [];
                dtlArr.head.forEach(item => {
                    if (item.children && Array.isArray(item.children) && item.children.length > 0) {
                        item.children.forEach(child => { if (child.status == 1) flatHead.push(child); });
                    } else if (item.status == 1) { flatHead.push(item); }
                });
                columns.forEach((column, index) => {
                    if (index === 0) { sums[index] = '合计'; return; }
                    const sumColumns = flatHead.filter(item => item.issum == 1);
                    const sumFields = sumColumns.map(item => item.field);
                    if (sumFields.includes(column.property)) {
                        const columnDataValues = data.map(item => {
                            let value = item[column.property] || '0';
                            value = value.toString().replace(/,/g, '');
                            return Number(value);
                        });
                        if (!columnDataValues.every(value => isNaN(value))) {
                            sums[index] = columnDataValues.reduce((prev, curr) => isNaN(curr) ? prev : prev + curr, 0);
                        } else { sums[index] = ''; }
                        let decimalPlaces = 0;
                        const fmtnumToDecimalPlaces = { qty: systemSet.qty, amt: systemSet.amt, rate: systemSet.rate, wgt: systemSet.wgt };
                        sumColumns.forEach(item => { if (item.field === column.property) { decimalPlaces = fmtnumToDecimalPlaces[item.fmtNum] || 0; } });
                        if (sums[index] !== '') {
                            sums[index] = sums[index].toFixed(decimalPlaces);
                            const [integerPart, decimalPart] = sums[index].toString().split('.');
                            const withCommas = integerPart.replace(/\B(?=(\d{3})+(?!\d))/g, ',');
                            sums[index] = decimalPart ? `${withCommas}.${decimalPart}` : withCommas;
                        }
                    }
                });
            } catch (error) { console.error('Error in getSummaries:', error); }
            return sums;
        }
    }
};
</script>

<style lang="scss" scoped>
.big_box {
    background: #fff;
    &.inline-mode { padding: 0 20px; }
    &.drawer-mode { padding: 20px; }
    .header_warpper {
        display: flex;
        justify-content: space-between;
        align-items: center;
        .left {
            display: flex;
            align-items: center;
        }
    }
    .header_warpper.inline-mode {
        background: #fff;
        // padding: 25px;
        min-height: 50px;
        border-bottom: 10px solid #f7f7f7;
    }
    .header_warpper.drawer-mode {
    }
    .selectTableBox.inline-mode {
        background: #fff;
        // padding: 20px;
        margin-top: 10px;
    }
    .selectTableBox.drawer-mode {
    }
}
/deep/.el-tabs__nav-wrap::after {
    background-color: #fff;
}
/deep/.el-tabs__item {
    width: 66px;
    text-align: center;
    padding: 0;
    font-size: 12px;
}
/deep/.el-tabs__active-bar {
    width: 66px !important;
}
.selectTableBox {
    /deep/ .has-gutter tr td .cell:empty::before {
    }
    /deep/ .el-table__footer-wrapper tbody td,
    .el-table__header-wrapper tbody td {
    }
    /deep/ .el-table__footer-wrapper .is-leaf {
    }
    /deep/ .el-table__fixed-footer-wrapper tbody td {
        color: #f50b0b;
    }
    /deep/ .has-gutter tr td .cell {
        font-weight: bold;
        color: #f50b0b;
    }

    /deep/ .el-table {
        display: flex;
        flex-direction: column;
    }

    /deep/ .el-table__body-wrapper {
        order: 0;
    }

    /deep/ .el-table__fixed-body-wrapper {
    }

    /deep/ .el-table__fixed-footer-wrapper {
        font-weight: bold;
    }
}
.pagination {
    margin-top: 10px;
    display: flex;
    justify-content: flex-end;
}
.drawer-wrapper {
    padding: 10px;
}
.filter-footer {
    padding: 12px 0;
    text-align: right;
}
// .filterKey_box {
//     .box_header {
//         display: flex;
//         justify-content: space-between;
//         align-items: center;
//         padding: 15px;
//         border-bottom: 1px solid #ebeef5;
//         font-size: 16px;
//         font-weight: bold;
//         .icon { cursor: pointer; font-size: 18px; }
//     }
//     .box_content {
//         padding: 10px;
//         .small_box {
//             margin-bottom: 20px;
//             .text {
//                 display: flex;
//                 justify-content: space-between;
//                 padding: 10px;
//                 font-weight: bold;
//                 .small { font-weight: normal; color: #909399; font-size: 12px; }
//             }
//             .ul {
//                 list-style: none;
//                 padding: 0;
//                 margin: 0;
//                 max-height: 300px;
//                 overflow-y: auto;
//                 .li {
//                     display: flex;
//                     align-items: center;
//                     padding: 10px 15px;
//                     border: 1px solid #ebeef5;
//                     border-radius: 4px;
//                     margin-bottom: 5px;
//                     cursor: pointer;
//                     background: #fff;
//                     transition: all 0.3s;
//                     .icon, .icon2 { margin-right: 8px; color: #606266; }
//                     .delIcon { margin-left: auto; color: #f50b0b; }
//                     &:hover { background: #ecf5ff; border-color: #409eff; }
//                     &.hover { background: #f5f7fa; }
//                 }
//             }
//         }
//         .box_btn {
//             display: flex;
//             justify-content: flex-end;
//             padding: 15px;
//             border-top: 1px solid #ebeef5;
//             button { margin-left: 10px; }
//         }
//     }
// }
</style>
